import { c } from "./createLucideIcon-Bs_bgX_W.js";
/**
 * @license lucide-react v0.508.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], t = c("check", e);
export {
  t as C
};
//# sourceMappingURL=check-VaVUBvxu.js.map
